import React from "react";
import {
  BrowserRouter as Router,
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import loadable from "./utils/loadable";
import "./style/base.scss";
import "./style/App.scss";

// 公共模块
const DefaultLayout = loadable(() => import("./containers/DefaultLayout"));

// 基础页面
// // const View404 = loadable(() => import("./views/Others/404"));

const App = () => (
  <Router>
    <BrowserRouter>
      <Route path="/" exact render={() => <Redirect to="/liveManage" />} />
      <Route component={DefaultLayout} />
      {/* <Route path="/404" component={View404} /> */}
    </BrowserRouter>
  </Router>
);

export default App;
